import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, input, Input, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OnInit } from '@angular/core';
import { TmsMastersDataService } from '../../../../../data-services/tms-masters-data.service';
import { MatRadioModule } from "@angular/material/radio";
import { CommonModule } from '@angular/common';


import { TmsTrainingDataService } from '../../../../../data-services/tms-training-data.service';
import { AlertsService } from '../../../../../ui-framework/global-services/utility-service/alerts-service';
import { TrainingPlan } from '../../../../../data-services/api-models/training-service-models';

@Component({
  selector: 'app-feedback-submission',
  standalone: true,
  imports: [MatTabsModule, MatExpansionModule, MatRadioModule, MatIconModule, MatSelectModule, MatInputModule, MatFormFieldModule, CommonModule],
  templateUrl: './feedback-submission.component.html',
  styleUrl: './feedback-submission.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackSubmissionComponent implements OnInit {
  readonly panelOpenState = signal(false);
  FeedbackSubmissionOptionsList = signal<any[]>([]);
  selectedAnswers = signal<{ [questionId: string]: string }>({});
  trainingPlanData = input<TrainingPlan[]>();
  HideSaveButton = input<boolean>(false);
  trainingIdandlastVersionId: { Id: string | undefined, versionID: string | undefined } = { Id: undefined, versionID: undefined }

  constructor(private tmsapiService: TmsMastersDataService, private readonly TmsTrainingplan: TmsTrainingDataService, private readonly alertsService: AlertsService, private cdr: ChangeDetectorRef) {
    effect(() => {
      const data = this.trainingPlanData();
      if (data && data?.length > 0) {
        this.trainingIdandlastVersionId.Id = data[0].id,
          this.trainingIdandlastVersionId.versionID = data[0].lastVersionId,

          this.CallFeedackForm();
      }
    })
  }

  ngOnInit(): void {
    // this.CallFeedackForm();   // for testing purpose only, as this will call in effect when input get the value from parent component
  }

  CallFeedackForm() {
    this.tmsapiService
      .getFeedbackSubmissionQuestion('30')
      .subscribe((res) => {

        const data = res.map((x: any) => ({
          id: x.id,
          code: x.code,
          description: x.description,
          isCodeRequired: x.isCodeRequired,
          isActive: x.isActive,
          isInternal: x.isInternal,
          trainingCategoryId: x.trainingCategoryId,
          feedbackFor: x.feedbackFor,
          noOfOption: x.noOfOption,
          slNo: x.slNo,
          subTypeId: x.subTypeId,

          feedackoptions: this.sortFeedbackOptions((x.feedbackMcqOption ?? []).map((y: any) => ({
            optionsid: y.optionValueId,
            description: y.description,
            optionRating: y.optionRating
          })))
        }));

        this.FeedbackSubmissionOptionsList.set(data);

        this.loadExistingFeedback();
      });
  }
 onOptionChange(questionId: string, optionId: string) {
  const answers = { ...this.selectedAnswers() };
  answers[questionId] = optionId;
  this.selectedAnswers.set(answers);
}



  saveFeedback() {
    if (!this.trainingIdandlastVersionId.Id) return;

    this.TmsTrainingplan
      .getTrainingAssessmentSubmissionByTrainingPlanId(this.trainingIdandlastVersionId.Id)
      .subscribe({
        next: (res) => {

          if (res && res.length > 0) {
            this.alertsService.showErrorAlert(
              'Feedback already submitted for this training plan.'
            );
            return;
          }

          //Note: call if only pass validation
          const questions = this.FeedbackSubmissionOptionsList();

          const payload = questions.map(q => {

            const selectedOptionId = this.selectedAnswers()[q.id];

            return {
              id: undefined,
              code: q.code,
              description: q.description,
              planId: this.trainingIdandlastVersionId.Id,
              planVersionId: this.trainingIdandlastVersionId.versionID,
              questionId: q.id,
              answerId: selectedOptionId,
              subTypeId: q.subTypeId
            };

          });

          this.TmsTrainingplan.postTrainingAssessmentSubmission(payload).subscribe({
            next: () => {
              this.alertsService.showSuccessAlert('Feedback saved successfully');
              this.CallFeedackForm();
            }
          });

        }
      });
  }

  loadExistingFeedback() {
  if (!this.trainingIdandlastVersionId.Id) return;

  this.TmsTrainingplan
    .getTrainingAssessmentSubmissionByTrainingPlanId(this.trainingIdandlastVersionId.Id)
    .subscribe(res => {

      if (!res || res.length === 0) return;

      const answers: any = {};

      res.forEach((item: any) => {
        answers[item.questionId] = item.answerId;
      });

      this.selectedAnswers.set(answers);

      this.cdr.markForCheck();   // ✅ VERY IMPORTANT
    });
  }

  private sortFeedbackOptions(options: any[]): any[] {
    return [...options].sort((left, right) =>
      this.getFeedbackOptionOrder(left?.description) - this.getFeedbackOptionOrder(right?.description)
    );
  }

  private getFeedbackOptionOrder(description?: string): number {
    const normalized = String(description ?? '').trim().toLowerCase();
    if (normalized.includes('yes') || normalized.includes('হ্যাঁ')) {
      return 0;
    }
    if (normalized.includes('no') || normalized.includes('না')) {
      return 1;
    }
    return 2;
  }
}

